import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Subscription, Observable, interval } from 'rxjs';
import { IUserProfile } from '../login/login';
import { AuthService } from '../service/auth.service';

@Injectable()
export class LoggedInGuard implements CanActivate {

  userProfileData: IUserProfile;
  public timeoutTime: number;
  public counter = 1;

  constructor(private msalService: MsalService,
    private router: Router,
    private authService: AuthService) { }

  canActivate() {
    console.log('login gaurd called');
    if (sessionStorage.getItem('IsAuthenticated') && this.isSessionValid()) {
      console.log('login guard is Authenticated');
      return true;
    } else {
      if (this.msalService.instance.getActiveAccount()) {
        console.log('login guard Authenticated');
        if (sessionStorage.getItem('IsSessionValid') === null) {
          this.authService.getAuthentication().subscribe(response => {
            if (response != null) {
              console.log(response);
              this.userProfileData = response;
              if (this.userProfileData.IsAuthenticated) {
                sessionStorage.setItem('firstName', this.userProfileData.FirstName);
                sessionStorage.setItem('lastName', this.userProfileData.LastName);
                sessionStorage.setItem('emailId', this.userProfileData.EmailId);
                sessionStorage.setItem('userName', this.userProfileData.UserName);
                sessionStorage.setItem('IsAdmin', String(this.userProfileData.IsAdmin));
                sessionStorage.setItem('IsAuthenticated', String(this.userProfileData.IsAuthenticated));
                sessionStorage.setItem('RoleID', String(this.userProfileData.RoleID));
                sessionStorage.setItem('loggedinTime', JSON.stringify(new Date(Date.now())));
                sessionStorage.setItem('IsSessionValid', JSON.stringify(true));
                // HighlightHometab
                this.router.navigate(['']);

              } else {
                console.log('User is Not Authenticated');
                this.router.navigate(['/Unauthorized']);
              }
            } else {
              console.log('API response is null');
              this.router.navigate(['/Unauthorized']);
            }
          });
        }
        // } else {
        //   return false;
        // }
        return true;
      } 
      else {
        console.log('login guard not authenticated');
        this.router.navigate(['/login']);
        return false;
      }
    }
  }

  isSessionAlive() {
    const count = 5;
    interval(1000 * 60).subscribe(x => {   // fire every second
      this.timeoutTime = this.getCurrentTimeInterval(); // change 2 to 24 , 5 to 30
      if (this.timeoutTime > 24 && (this.timeoutTime < 30 || this.timeoutTime === 30)) { // && count !== 0
        const time = 30 - this.timeoutTime;
        if (time === 4 && this.counter === 1) {
          alert('Session will expire in ' + count + ' mins');
          this.counter = 0;
        }
        // this.test(count);
      } else {
        // Time out at 30th min
        if (this.timeoutTime === 30 || this.timeoutTime > 30) {
          this.router.navigate(['/timeout']);
        }
      }
    });
  }

  getCurrentTimeInterval() {
    const loggedInTime = Date.parse((JSON.parse(sessionStorage.getItem('loggedinTime'))));
    const currentTime = Date.parse(new Date(Date.now()).toString());
    const difference = currentTime - loggedInTime;
    return Math.floor((difference / 1000) / 60);
  }

  isSessionValid() {
    this.isSessionAlive();
    const globalTimeInterval = 600; // for 10 hrs
    const SpecifiedTimeInterval = 30; // chage 5 to 30

    const currentInterval = this.getCurrentTimeInterval();
    this.timeoutTime = currentInterval;

    if (currentInterval < globalTimeInterval) {

      if (currentInterval < SpecifiedTimeInterval) {
        sessionStorage.setItem('loggedinTime', JSON.stringify(new Date(Date.now())));
        return true;
      } else {
        this.router.navigate(['/timeout']);
      }

    } else {
      sessionStorage.removeItem('firstName');
      sessionStorage.removeItem('lastName');
      sessionStorage.removeItem('emailId');
      sessionStorage.removeItem('userName');
      sessionStorage.removeItem('IsAdmin');
      sessionStorage.removeItem('IsAuthenticated');
      sessionStorage.removeItem('RoleID');
      sessionStorage.removeItem('loggedinTime');
      sessionStorage.removeItem('IsSessionValid');
      this.router.navigate(['']);
    }
  }
}
